// extracted by mini-css-extract-plugin
module.exports = {"Card":"NewMiscForm_Card__20mVg","Inputs":"NewMiscForm_Inputs__1abO0","Actions":"NewMiscForm_Actions__2yXeP"};